import { create } from 'zustand';

const useDialogStore = create((set) => ({
  // State
  isOpen: false,
  type: 'alert', // 'alert' or 'confirm'
  title: '',
  message: '',
  confirmText: 'OK',
  cancelText: 'Cancel',
  onConfirm: null,
  onCancel: null,

  // Actions
  alert: (message, title = 'Notice') => {
    return new Promise((resolve) => {
      set({
        isOpen: true,
        type: 'alert',
        title,
        message,
        confirmText: 'OK',
        onConfirm: () => {
          set({ isOpen: false });
          resolve();
        },
        onCancel: null,
      });
    });
  },

  confirm: (message, title = 'Confirm', confirmText = 'OK', cancelText = 'Cancel') => {
    return new Promise((resolve) => {
      set({
        isOpen: true,
        type: 'confirm',
        title,
        message,
        confirmText,
        cancelText,
        onConfirm: () => {
          set({ isOpen: false });
          resolve(true);
        },
        onCancel: () => {
          set({ isOpen: false });
          resolve(false);
        },
      });
    });
  },

  close: () => set({ isOpen: false }),
}));

export { useDialogStore };
